export default __webpack_public_path__ + "static/media/certification2.83d1df8b.jpg";